import styled from "styled-components";

export const RadioWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const RadioInput = styled.input`
  margin: 0 8px 0 0;
  width: 20px;
  height: 20px;
  border: 2px solid ${({ theme }) => theme.colors.brand["500"]};
  border-radius: 50%;
  outline: none;
  transition: 0.2s;
  cursor: pointer;
  accent-color: ${({ theme }) => theme.colors.brand["500"]};
`;

export const RadioLabel = styled.label`
  font-size: 16px;
`;
